import { render } from "./TournamentScheduleCreatePage.vue?vue&type=template&id=31c9ce4c"
import script from "./TournamentScheduleCreatePage.vue?vue&type=script&lang=js"
export * from "./TournamentScheduleCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__